<template>
  <section>
    <b-button @click="onClick" class="infobutton">
      <i class="fas fa-info-circle"></i>
    </b-button>
  </section>
</template>

<script>
import device from 'current-device'
import { mapState } from 'vuex'

export default {
  name: 'InfoButton',
  async created() {
    let scope = this
    window.onscroll = function() {
      scope.checkOffset()
    }

    await this.$store.dispatch('infobutton/fetchData')
    try {
      this.loading = false
    } catch (error) {
      console.log(error)
    }
  },
  mounted() {
    setTimeout(() => {
      this.checkOffset()
    }, 1000)
    window.addEventListener('resize', this.checkOffset)
  },
  destroyed() {
    window.removeEventListener('resize', this.checkOffset)
  },
  methods: {
    onClick() {
      window.open(this.data.url, '_blank')
    },
    checkOffset() {
      let gap = 32
      if (device.type == 'mobile') {
        gap = 16
      }

      let infoButton = document.getElementsByClassName('infobutton')[0]
      let a = document.documentElement.scrollTop + window.innerHeight
      let b = document.getElementsByClassName('footer')[0].offsetTop

      infoButton.style.right = gap + 'px'

      if (a < b) {
        infoButton.style.bottom = gap + 'px'
      } else {
        infoButton.style.bottom = gap + (a - b) + 'px'
      }
    }
  },
  computed: {
    ...mapState('infobutton', ['data'])
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.checkOffset()
      }, 600)
    }
  }
}
</script>

<style lang="scss" scoped></style>
